import { RichContent } from '@corratech/pylot-rich-content'
import React, { memo, ReactElement } from 'react'
import s from '@pagestyles/PDP.module.scss'
import { useTranslation } from 'next-i18next'
import st from './ProductInfo.module.scss'
import cn from 'classnames'
import { useIsMobile } from '@components/common/IsMobile/useIsMobile'
import { Accordion } from '@corratech/pylot-ui'

type ProductInfoProps = {
    description?: {
        html?: string
    }
    assemblyCare?: string
    whatsInBox?: string
    faq?: string
    certificateOfAnalysis?: string
    descriptionTitle?: string
    whatsInBoxTitle?: string
    assemblyCareTitle?: string
    faqTitle?: string
    warranty?: string
    warrantyTitle?: string
}

const ProductInfoComponent = ({
    description = {},
    assemblyCare,
    whatsInBox,
    faq,
    certificateOfAnalysis,
    descriptionTitle,
    whatsInBoxTitle,
    assemblyCareTitle,
    faqTitle,
    warranty,
    warrantyTitle
}: ProductInfoProps): ReactElement | null => {
    const { html } = description
    const { t } = useTranslation(['common'])
    const isMobile = useIsMobile()

    if (
        !html &&
        !assemblyCare &&
        !whatsInBox &&
        !faq &&
        !certificateOfAnalysis &&
        !warranty
    ) {
        return null
    }

    let tabs = [
        {
            title: descriptionTitle ?? t('Overview'),
            content: html
        },
        {
            title: whatsInBoxTitle ?? t('What’s in the Box'),
            content: whatsInBox
        },
        {
            title: assemblyCareTitle ?? t('Assembly and Care'),
            content: assemblyCare
        },
        {
            title: faqTitle ?? t('FAQ'),
            content: faq
        },
        {
            title: t('Certificate of analysis'),
            content: certificateOfAnalysis
        },
        {
            title: warrantyTitle ?? t('Warranty'),
            content: warranty
        }
    ]

    tabs = tabs.filter((tab, index) => {
        if (tab.content) return true
        return false
    })

    const contents = tabs.map((tab, index) => ({
        id: (index + 1).toString(),
        Title: function AccordionTitle() {
            return <div className={st['accordian-title']}>{tab.title}</div>
        },
        Content: function AccordionContent() {
            return <RichContent html={tab.content} />
        },
        initialState: index === 0
    }))

    return contents?.length ? (
        <div className={cn(s['pdp-info-wrap'], st['pdp-info-wrap'])}>
            <Accordion contents={contents} />
        </div>
    ) : null
}

export const ProductInfo = memo(ProductInfoComponent)
